import React, { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import API from "utils/API";

const NDCList = ({ selectedNDC, onSelect }) => {
  const [ndcName, setNDCName] = useState("");
  const [ndcOpt, setNDCOpt] = useState([]);
  const [ndcLoading, setNdCLoading] = useState(false);

  useEffect(() => {

    if (ndcOpt.length && !selectedNDC) {
      setNDCOpt([]);
    }
  }, [selectedNDC]);

  const handleChangeProvider = async (value) => {
    setNDCName(value);
    if (value.length >= 3) {
      setNdCLoading(true);
      try {
      const result = await API.get(`GWConfig/AutoSearch/NdcList/${value}`,{
          hasDefaultURL: true,
        });
        if (result?.data?.length > 0) {
          setNDCOpt(result.data);
          setNdCLoading(false);
        } else {
          setNDCOpt([]);
          setNdCLoading(false);
        }
      } catch (error) {
        setNdCLoading(false);
      }
    }
  };

  const onSelectNdc = (provider) => {
    onSelect(provider);
  };

  return (
    <Select
      className="form-field-large inner-shadow-field autondc"
      classNamePrefix="select"
      IndicatorSeparator
      isClearable={true}
      isSearchable={true}
      isLoading={ndcLoading}
      placeholder="Enter Drug Name Or NDC"
      name="color"
      portalId="root portal"
      options={ndcOpt}
      inputValue={ndcName}
      value={selectedNDC}
      onInputChange={handleChangeProvider}
      onChange={onSelectNdc}
      getOptionLabel={(option) => option.description}
      getOptionValue={(option) => option.id}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
           zIndex: 99999,
        }),
      }}
    />
  );
};

export default NDCList;
